export const getApiUrl = () => {
  if (process.env.REACT_APP_API_CONFIG && process.env.REACT_APP_CONF_FILE) {
    const api = JSON.parse(process.env.REACT_APP_API_CONFIG)[process.env.REACT_APP_CONF_FILE];
    if (!api) {
      throw new Error(`No API configuration found for ${process.env.REACT_APP_CONF_FILE}`);
    }
    return `${api.host}/${api.version}`;
  }
};
